import ClientCURModule from "@/modules/ClientCUR";

function CreateClientPage() {
  return <ClientCURModule type="create" />;
}

export default CreateClientPage;
